import { MessageKey } from '../../i18n';
import { RING_DRILLS } from '../../sim/levels/ring';
import { laneLocal } from '../../sim/levels/zielonka';
import { isWheelspin } from '../../sim/grip';
import { DRILL_CONFIG } from '../config';
import { BaseDrill, DrillResult, Stars, frontAxle, round } from '../drill';
import { FrameState } from '../frame';

const C = DRILL_CONFIG.throttle;
const G = RING_DRILLS.throttle;

/** Drill 1: roll on the throttle through a 30 m lane to a gate without wheelspin or a wheelie. */
export class ThrottleDrill extends BaseDrill {
  readonly id = 'throttle' as const;
  readonly start = 'throttle';
  protected readonly timeLimit = C.timeLimit;
  maxSlip = 0;
  /** s of wheelspin (isWheelspin) during the run. */
  spin = 0;
  wheelie = 0;
  elapsed = 0;

  protected shouldStart(f: FrameState) { return f.input.throttle > C.startThrottle; }

  protected metrics() {
    return { time: round(this.elapsed), slip: round(this.maxSlip), wheelie: round(this.wheelie) };
  }

  protected track(f: FrameState): DrillResult | null {
    const b = f.bike;
    this.elapsed = f.time - this.startTime;
    this.maxSlip = Math.max(this.maxSlip, b.telemetry.rearSlip);
    if (isWheelspin(b.telemetry)) this.spin += f.dt;
    const [rear, front] = b.wheels;
    if (rear.contact && !front.contact && b.telemetry.speed > C.wheelieMinSpeed) this.wheelie += f.dt;
    if (Math.abs(laneLocal(G, b.position.x, b.position.z).side) > G.halfWidth + C.laneMargin) return this.fail('result.reason.leftLane');
    const axle = frontAxle(f, this.cfg);
    if (laneLocal(G, axle.x, axle.z).along < G.length) return null;

    const reasons: MessageKey[] = [];
    const t3 = C.tiers[3], t2 = C.tiers[2];
    if (this.spin > t3.maxSpin) reasons.push('result.reason.rearSlip');
    if (this.wheelie > t3.maxWheelie) reasons.push('result.reason.wheelie');
    if (this.elapsed > t3.maxTime) reasons.push('result.reason.slow');
    const meets = (t: { maxSpin: number; maxWheelie: number; maxTime: number }) =>
      this.spin <= t.maxSpin && this.wheelie <= t.maxWheelie && this.elapsed <= t.maxTime;
    const stars: Stars = meets(t3) ? 3 : meets(t2) ? 2 : 1;
    return { stars, metrics: this.metrics(), reasons };
  }
}
